import { render } from "./AccountOnboardingLookingForPage.vue?vue&type=template&id=47cf9944&ts=true"
import script from "./AccountOnboardingLookingForPage.vue?vue&type=script&lang=ts"
export * from "./AccountOnboardingLookingForPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__